// 字串屬性的可選值（vms#35）：設備在生效能力（`thing.capabilities.effective[].values`）宣告的值域子集，
// 例 `kinio_video.main_resolution` 的 "2304x1296"。設定 API 的 item 只有數字 enum，字串 select 的選項照這份畫、寫回原字串。
// 規則同 App（iOS / Android `KinioCapLimits.stringValues`）：照宣告順序、只收字串；沒宣告 → null（唯讀顯示目前值）。

const RES_RE = /^(\d+)x(\d+)$/;

function obj(v: unknown): Record<string, unknown> | null {
  return v && typeof v === 'object' && !Array.isArray(v) ? (v as Record<string, unknown>) : null;
}

/** thing.capabilities + `<cluster>.<attr>` → 宣告的字串值（照宣告順序、去重）；沒宣告 / 不是字串 → null。 */
export function capStringValues(capabilities: unknown, key: string): string[] | null {
  const eff = obj(capabilities)?.effective;
  if (!Array.isArray(eff)) return null;
  const dot = key.indexOf('.');
  if (dot <= 0) return null;
  const cluster = key.slice(0, dot);
  const attr = key.slice(dot + 1);
  const out: string[] = [];
  for (const e of eff.map(obj)) {
    if (e?.cluster !== cluster) continue;
    const vs = obj(e.values)?.[attr];
    if (!Array.isArray(vs)) continue;
    for (const v of vs) if (typeof v === 'string' && v !== '' && !out.includes(v)) out.push(v);
  }
  return out.length > 0 ? out : null;
}

/** 選項文字：解析度 "2304x1296" 寫 "2304×1296"，其他照原字串。 */
export function capStringText(v: string): string {
  const m = RES_RE.exec(v);
  return m ? `${m[1]}×${m[2]}` : v;
}
